import { ReactTFC } from "../../../../../utils/fp/missing-ts-parts";
import { NewsletterLandingPageDataData } from "@swo/storefront";

import { css } from "@emotion/react";

import { CSS_COLORS } from "../../../../../styles/styles-css-variables";
import { option } from "fp-ts";
import React from "react";

import { CSS_MQ } from "../../../../../styles/breakpoints";
import { FONTS, fontSize } from "../../../../../styles/fonts";
import { DownArrowSvg } from "../../../../../assets";

const selectStyles = [
  FONTS.SwarovskiFutura500,
  fontSize.x2,
  css`
    -webkit-appearance: none;
    -moz-appearance: none;

    height: 55px;
    width: 100%;

    border: 0;
    border-top: 1px solid ${CSS_COLORS.Grey};
    border-bottom: 1px solid ${CSS_COLORS.Grey};
    border-radius: 0;

    padding: 0 20px;

    background: white;
  `,
];

type NewsletterCountries = NewsletterLandingPageDataData["countries"];
type NewsletterLanguages = NewsletterLandingPageDataData["languages"];

export const CountryAndLanguageSelector: ReactTFC<{
  countries: NewsletterCountries;
  languages: NewsletterLanguages["fallback"];
  selectedCountry: NewsletterCountries[number];
  selectedLanguage: NewsletterLanguages["fallback"][number];
  onCountryChange: (country: NewsletterCountries[number]) => void;
  onLanguageChange: (language: NewsletterLanguages["fallback"][number]) => void;
}> = props => {
  const selectWrapperStyles = css`
    position: relative;
  `;

  const chevronStyles = css`
    --size: 16px;

    position: absolute;
    right: 4px;
    top: calc(50% - var(--size) * 0.5);

    display: block;

    color: black;

    margin-bottom: 24px;
    margin-left: auto;
    margin-right: auto;

    width: var(--size);
    height: var(--size);

    pointer-events: none;
  `;

  return (
    <div
      css={css`
        display: grid;

        ${CSS_MQ.atMostSm} {
          grid-template-rows: 1fr 1fr;
          grid-row-gap: 10px;
          width: 100%;
        }

        ${CSS_MQ.atLeastMd} {
          grid-template-columns: 1fr 1fr;
          grid-column-gap: 20px;
        }
      `}
    >
      <div css={selectWrapperStyles}>
        <select
          css={selectStyles}
          value={props.selectedCountry.isoCode.toLowerCase()}
          onChange={e => {
            const { value } = e.target;

            const country = props.countries.find(c => c.isoCode.toLowerCase() === value.toLowerCase());

            if (country) {
              props.onCountryChange(country);
            }
          }}
        >
          {props.countries.map(country => (
            <option key={country.isoCode} value={country.isoCode.toLowerCase()}>
              {country.label}
            </option>
          ))}
        </select>

        <DownArrowSvg css={chevronStyles} />
      </div>

      <div css={selectWrapperStyles}>
        <select
          css={selectStyles}
          value={props.selectedLanguage.isoCode}
          onChange={e => {
            const { value } = e.target;

            const language = props.languages.find(c => c.isoCode === value);

            if (language) {
              props.onLanguageChange(language);
            }
          }}
        >
          {props.languages.map(language => (
            <option key={language.isoCode} value={language.isoCode}>
              {language.label}
            </option>
          ))}
        </select>

        <DownArrowSvg css={chevronStyles} />
      </div>
    </div>
  );
};
